import { makeObservable, computed, observable, action } from 'mobx';
import { inject, injectable } from '@servicetitan/react-ioc';
import { TableState } from '@servicetitan/table';

import { PhoneData } from '../types/phone-data';
import { PhonesStore } from './phones.store';

@injectable()
export class PhonesActionsCellStore {
    @observable dialogForDataItem: PhoneData | null = null;

    constructor(@inject(PhonesStore) private phonesStore: PhonesStore) {
        makeObservable(this);
    }

    @computed get tableState(): TableState<PhoneData, string> {
        return this.phonesStore.tableState;
    }

    @action showDialog = (dataItem: PhoneData) => (this.dialogForDataItem = dataItem);
    @action hideDialog = () => (this.dialogForDataItem = null);

    handleEdit = (dataItem: PhoneData) => {
        this.tableState.cancelEditAll();
        this.tableState.edit(dataItem);
    };

    handleSave = async (dataItem: PhoneData) => {
        const form = this.tableState.inEdit.get(dataItem.id);
        const forwardToField = form?.form.$.forwardTo;
        const smsField = form?.form.$.sms;

        if (forwardToField) {
            if (forwardToField.dirty || smsField?.dirty) {
                const { hasError } = await forwardToField.enableAutoValidationAndValidate();

                if (!hasError) {
                    await this.phonesStore.savePhone(dataItem, {
                        forwardTo: forwardToField.value,
                        sms: smsField?.value || false,
                    });

                    this.tableState.cancelEdit(dataItem);
                }
            } else {
                this.tableState.cancelEdit(dataItem);
            }
        }
    };

    handleDeallocate = async () => {
        if (this.dialogForDataItem) {
            await this.phonesStore.deallocatePhone(this.dialogForDataItem);
            this.hideDialog();
        }
    };

    handleCancel = (dataItem: PhoneData) => {
        this.tableState.cancelEdit(dataItem);
    };
}
